import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaArrowRight, FaArrowUp, FaPlus, FaTrash } from 'react-icons/fa';

import ReportAPI from '../../api/ReportAPI';
import MainCondition from '../settings/condition/MainCondition';
import AutomationModuleSelect from '../settings/automation/AutomationModuleSelect';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import FieldController from '../../controller/FieldController';
import Util from '../../util/Util';
import ApiUiController from '../../controller/ApiUiController';
import RegEx from '../../util/RegEx';

import ReportUpdateType from './ReportUpdateType';
import ReportUpdateView from './ReportUpdateView';

import '../settings/Settings.css';
import ReportConstants from '../../util/ReportConst';

class ReportUpdateComplex extends React.Component {

  constructor(props) {
    super(props);

    this.id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: true, name: '',
      type: 0, view_type: 0,
      model: '', subModel: '',
      modelKey: '', subModelKey: '',
      xModel: '', yModel: '', zModel: '', x: '', y: '', z: '',
      filter: [], inValid: {},
      fields: []
    };

    this.models = reactLocalStorage.getObject(Const.Model);

    this.modelFields = [];
    this.subModelFields = [];
    this.modelConditionalFields = [];
    this.subModelConditionalFields = [];
    this.conditionsModel = [];
    this.conditionsSubModel = [];
    this.zFields = [];

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/add-edit'));
    this.report = {};

    this.Zaxis = [{ label: 'Count', value: 'COUNT' }, { label: 'Total/Sum', value: 'SUM' }];
  }

  componentDidMount() {
    if (this.id !== 0) {
      ReportAPI.get(this.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onReceived = report => {
    this.report = report;

    const model = report.model.includes(' ') ? report.model.split(' ') : [report.model];
    const subModel = report.sub_model && report.sub_model.includes(' ')
      ? report.sub_model.split(' ') : null;

    this.model = this.models[model[0]];
    this.subModel = subModel ? this.models[subModel[0]] : this.model;
    this.modelConditionalFields = FieldController.getFilterFields(this.model.fields);
    this.subModelConditionalFields = FieldController.getFilterFields(this.subModel.fields);
    this.modelFields = [];
    let keys = Object.keys(this.models[model[0]].fields);
    for (let i = 0; i < keys.length; i++) {
      this.modelFields.push({
        id: this.models[model[0]].fields[keys[i]].id,
        value: this.models[model[0]].fields[keys[i]].field_key,
        type: this.models[model[0]].fields[keys[i]].field_type,
        label: this.models[model[0]].fields[keys[i]].label_name
      });
    }
    this.subModelFields = [];
    if (subModel) {
      keys = Object.keys(this.models[subModel[0]].fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.models[subModel[0]].fields[keys[i]].id,
          value: this.models[subModel[0]].fields[keys[i]].field_key,
          type: this.models[subModel[0]].fields[keys[i]].field_type,
          label: this.models[subModel[0]].fields[keys[i]].label_name
        });
      }
    } else {
      keys = Object.keys(this.models[model[0]].fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.models[model[0]].fields[keys[i]].id,
          value: this.models[model[0]].fields[keys[i]].field_key,
          type: this.models[model[0]].fields[keys[i]].field_type,
          label: this.models[model[0]].fields[keys[i]].label_name
        });
      }
    }

    const x = report.x && report.x.includes('.') ? report.x.split('.') : ['', report.x];
    const y = report.y && report.y.includes('.') ? report.y.split('.') : ['', report.y];

    let xModel;
    let yModel;
    if (!x[0] || !y[0]) {
      xModel = x ? this.models[model[0]].model_key : null;
      yModel = y ? this.models[model[0]].model_key : null;
    } else {
      xModel = x ? this.models[x[0] === model[1] ? model[0] : subModel[0]].model_key : null;
      yModel = y ? this.models[y[0] === model[1] ? model[0] : subModel[0]].model_key : null;
    }

    let conditions = [];
    try {
      conditions = JSON.parse(report.filter);
    } catch (err) {
      console.log(err);
    }
    this.conditionsModel = conditions.filter(condition => !condition.model_key
      || condition.model_key === model[0]);
    this.conditionsSubModel = subModel
      ? conditions.filter(condition => condition.model_key === subModel[0]) : [];

    const json = report.json ? JSON.parse(report.json) : {};

    let sum = report.sum && report.sum.trim() ? report.sum : (report.z ? report.z
      : (subModel ? `COUNT(${model.substring(0, 1)}.id)` : `COUNT(id)`));
    if (!sum.includes('(')) {
      sum = `COUNT(${sum})`;
    }

    const zValue = sum.toUpperCase().includes('SUM') ? this.Zaxis[1].value : this.Zaxis[0].value;
    sum = sum.split('(')[1];
    let zModel;
    if (sum.includes('.')) {
      zModel = sum.substring(0, 1) === model[0].substring(0, 1) ? model[0] : subModel[0];
      sum = sum.split('.')[1];
    } else {
      zModel = model[0];
    }
    const z = sum.replace('.', '').replace(')', '');
    this.zFields = [];
    this.zFields.push({ id: 0, value: 'id', type: 'id', label: 'Id' });
    keys = Object.keys(this.models[zModel].fields);
    for (let i = 0; i < keys.length; i++) {
      this.zFields.push({
        id: this.models[zModel].fields[keys[i]].id,
        value: this.models[zModel].fields[keys[i]].field_key,
        type: this.models[zModel].fields[keys[i]].field_type,
        label: this.models[zModel].fields[keys[i]].label_name
      });
    }

    this.setState({
      ...this.state,
      id: report.id,
      name: report.name,
      model: model[0],
      modelKey: model.length > 1 ? model[1] : null,
      subModel: subModel ? subModel[0] : null,
      subModelKey: subModel && subModel.length > 1 ? subModel[1] : null,
      type: report.type,
      view_type: report.view_type,
      xModel,
      yModel,
      zValue,
      zModel,
      x: x ? x[1] : null,
      y: y ? y[1] : null,
      z,
      ...json,
      inApiCall: false
    });
  };

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  onModelChange = (field, model) => {
    this.model = this.models[model];
    this.modelConditionalFields = FieldController.getFilterFields(this.model.fields);
    this.modelFields = [];
    const keys = Object.keys(this.model.fields);
    for (let i = 0; i < keys.length; i++) {
      this.modelFields.push({
        id: this.model.fields[keys[i]].id,
        value: this.model.fields[keys[i]].field_key,
        type: this.model.fields[keys[i]].field_type,
        label: this.model.fields[keys[i]].label_name
      });
    }
    this.setState({ ...this.state, model: model });
  };
  onSubModelChange = (field, subModel) => {
    this.subModel = null;
    this.subModelFields = [];
    this.subModelConditionalFields = [];
    if (subModel) {
      this.subModel = this.models[subModel];
      this.subModelConditionalFields = FieldController.getFilterFields(this.subModel.fields);
      const keys = Object.keys(this.subModel.fields);
      for (let i = 0; i < keys.length; i++) {
        this.subModelFields.push({
          id: this.subModel.fields[keys[i]].id,
          value: this.subModel.fields[keys[i]].field_key,
          type: this.subModel.fields[keys[i]].field_type,
          label: this.subModel.fields[keys[i]].label_name
        });
      }
    }
    this.setState({ ...this.state, subModel });
  };
  onXModelChange = (field, model) => {
    const xModel = model;
    this.setState({ ...this.state, xModel });
  };
  onYModelChange = (field, model) => {
    const yModel = model;
    this.setState({ ...this.state, yModel });
  };
  onZModelChange = (field, model) => {
    const zModel = model;
    this.zFields = [];
    if (model) {
      this.zFields.push({ id: 0, value: 'id', type: 'id', label: 'Id' });
      const keys = Object.keys(this.models[model].fields);
      for (let i = 0; i < keys.length; i++) {
        this.zFields.push({
          id: this.models[model].fields[keys[i]].id,
          value: this.models[model].fields[keys[i]].field_key,
          type: this.models[model].fields[keys[i]].field_type,
          label: this.models[model].fields[keys[i]].label_name
        });
      }
    }
    this.setState({ ...this.state, zModel });
  };
  onFieldChange = (field, value) => {
    const state = { ...this.state };
    state[field] = value;
    this.setState({ ...state });
  };

  onModelConditionChange = conditions => this.conditionsModel = conditions;
  onSubModelConditionChange = conditions => this.conditionsSubModel = conditions;

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    let report;
    if (this.state.subModel) {
      const modefilter = this.conditionsModel
        .filter(filter => Object.keys(filter).length !== 0)
        .map(filter => {
          return {
            model_key: this.state.model, field: filter.field.value,
            type: filter.field.type, condition: filter.condition.value, value: filter.value
          };
        });
      const subModefilter = this.conditionsSubModel
        .filter(filter => Object.keys(filter).length !== 0)
        .map(filter => {
          return {
            model_key: this.state.subModel, field: filter.field.value,
            type: filter.field.type, condition: filter.condition.value, value: filter.value
          };
        });
      const filter = JSON.stringify([...modefilter, ...subModefilter]);

      const json = JSON.stringify({ fields: [...this.state.fields] });

      const model = this.state.model + ' ' + this.state.model.substring(0, 1);
      const sub_model = this.state.subModel + ' ' + this.state.subModel.substring(0, 1);
      let x = '';
      if (this.state.x) {
        x = (this.state.model === this.state.xModel ? this.state.modelKey : this.state.subModelKey)
          + '.' + this.state.x;
      }
      let y = '';
      if (this.state.y) {
        y = (this.state.model === this.state.yModel ? this.state.modelKey : this.state.subModelKey)
          + '.' + this.state.y;
      }
      const z = this.state.z;
      const sum = this.state.zValue + '(' + this.state.zModel.substring(0, 1) + '.' + this.state.z + ')';

      report = {
        id: this.state.id,
        name: this.state.name,
        type: this.state.type,
        view_type: this.state.view_type,
        model,
        sub_model,
        x,
        y,
        z,
        filter,
        json,
        sum
      };
    } else {
      const filter = this.conditionsModel.map(filter => {
        if (Object.keys(filter).length === 0) return {};
        else return {
          field: filter.field.value,
          type: filter.field.type, condition: filter.condition.value, value: filter ? filter.value : ''
        };
      });
      const sum = this.state.zValue + '(' + this.state.z + ')';
      report = {
        id: this.state.id,
        name: this.state.name,
        type: this.state.type,
        view_type: this.state.view_type,
        model: this.state.model,
        sub_model: null,
        x: this.state.x,
        y: this.state.y,
        z: this.state.z,
        filter: JSON.stringify(filter),
        json: null,
        sum
      };
    }
    ReportAPI.save(report, this.onSaved, this.onFail);
  };

  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  onFieldAdd = () => {
    let fields = this.state.fields;
    if (!fields) {
      fields = [];
    }
    fields.push({});
    this.setState({ ...this.state, fields: [...fields] });
  };

  onFieldRemove = index => {
    let fields = [...this.state.fields];
    fields = fields.filter((_, i) => i !== index);
    this.setState({ ...this.state, fields: [...fields] });
  };

  render() {
    const inValid = this.state.inValid;
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder="Report Name"
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Module</h4></div>
                <AutomationModuleSelect onChange={this.onModelChange} model={this.state.model}
                  models={this.models} />
              </div>

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Sub Module</h4></div>
                <AutomationModuleSelect onChange={this.onSubModelChange} model={this.state.subModel}
                  models={this.models} />
              </div>
            </Form>

            <Form className="row row-cols-3 lead-form">
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>X-axis Module</h4></div>
                <AutomationModuleSelect onChange={this.onXModelChange} model={this.state.xModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>X-axis Co-ordinate <FaArrowRight /></h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={
                      (this.state.xModel === this.state.model ? this.modelFields
                        : this.state.xModel === this.state.subModel ? this.subModelFields
                          : [])
                        .find(field => field.value === this.state.x)}
                    className="mr-sm-2"
                    options={this.state.xModel === this.state.model ? this.modelFields
                      : this.state.xModel === this.state.subModel ? this.subModelFields
                        : []}
                    onChange={field => this.setState({ ...this.state, x: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Y-axis Module</h4></div>
                <AutomationModuleSelect onChange={this.onYModelChange} model={this.state.yModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Y-axis co-ordinate <FaArrowUp /></h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={
                      (this.state.yModel === this.state.model ? this.modelFields
                        : this.state.yModel === this.state.subModel ? this.subModelFields
                          : [])
                        .find(field => field.value === this.state.y)}
                    className="mr-sm-2"
                    options={this.state.yModel === this.state.model ? this.modelFields
                      : this.state.yModel === this.state.subModel ? this.subModelFields
                        : []}
                    onChange={field => this.setState({ ...this.state, y: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>
            </Form>

            <Form className="row row-cols-3 lead-form">
              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Count / Sum</h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    className="mr-sm-2"
                    value={this.Zaxis.find(field => field.value === this.state.zValue)}
                    options={this.Zaxis}
                    onChange={field => this.setState({ ...this.state, zValue: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col-md-3">
                <div className="formhead col-md-12"><h4>Count / Sum Module</h4></div>
                <AutomationModuleSelect onChange={this.onZModelChange} model={this.state.zModel}
                  models={this.models} restricted={[this.state.model, this.state.subModel]} />
              </div>

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Count / Sum Co-ordinate</h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.zFields.find(field => field.value === this.state.z)}
                    onChange={field => this.setState({ ...this.state, z: field ? field.value : '' })}
                    className="mr-sm-2" options={this.zFields} isSearchable={true} isClearable={true} />
                </div>
              </div>
            </Form>

            <Form className="row row-cols-3 lead-form">
              <ReportUpdateView
                value={this.state.view_type}
                onChange={value => this.onFieldChange('view_type', value)} />

              <ReportUpdateType
                value={this.state.type}
                onChange={value => this.onFieldChange('type', value)}
                x={this.state.x} y={this.state.y}
                xFields={this.state.xModel === this.state.model ? this.modelFields
                  : this.state.xModel === this.state.subModel ? this.subModelFields
                    : []}
                yFields={this.state.yModel === this.state.model ? this.modelFields
                  : this.state.yModel === this.state.subModel ? this.subModelFields
                    : []} />
            </Form>

            <Form className="row row-cols-3 lead-form">
              {this.state.model
                ? <MainCondition
                  title="Model Condition"
                  model={this.model}
                  fields={this.modelConditionalFields}
                  value={this.conditionsModel}
                  onConditionChanged={this.onModelConditionChange} />
                : null
              }

              {this.state.subModel
                ? <MainCondition
                  title="Sub Model Condition"
                  model={this.subModel}
                  fields={this.subModelConditionalFields}
                  value={this.conditionsSubModel}
                  onConditionChanged={this.onSubModelConditionChange} />
                : null
              }
            </Form>
            {this.state.view_type === ReportConstants.Download
              ? <>
                <Form className="row row-cols-3 lead-form">
                  <div className="formhead col-md-12">
                    <h4>Fields <FaPlus onClick={this.onFieldAdd} /></h4>
                  </div>
                </Form>
                {this.state.fields.map((field, i) =>
                  <Form className="row row-cols-3 lead-form" key={`fields_${i + 1}`}>
                    <div className="col-md-4">
                      <AutomationModuleSelect
                        model={field.model}
                        models={this.models}
                        restricted={[this.state.model, this.state.subModel]}
                        onChange={(field, model) => {
                          const fields = [...this.state.fields];
                          fields[i].model = model;
                          this.setState({ ...this.state, fields: [...fields] });
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <Select
                        value={(field.model === this.state.model ? this.modelFields
                          : field.model === this.state.subModel ? this.subModelFields
                            : [])
                          .find(innerField => innerField.value === field.field)
                        }
                        className="mr-sm-2"
                        options={field.model === this.state.model ? this.modelFields
                          : field.model === this.state.subModel ? this.subModelFields
                            : []
                        }
                        onChange={field => {
                          const fields = [...this.state.fields];
                          fields[i].field = field ? field.value : '';
                          this.setState({ ...this.state, fields: [...fields] });
                        }}
                        isSearchable={true} isClearable={true} />
                    </div>

                    <FaTrash onClick={() => this.onFieldRemove(i)} />
                  </Form>
                )}
              </>
              : null
            }

            <div className="col-md-12 text-center btnsend">
              <Button variant="success" onClick={this.onSave}>Save</Button>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ReportUpdateComplex);